import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";
import { BILLING_LABEL, sendToBilling } from "@/lib/bf";

export default function BFSendBilling({ row, firms, onDone }) {
  const [pick, setPick] = useState("");
  const [busy, setBusy] = useState(false);
  const st = row.billing?.status;
  if (st) return <span className={`bf-bill-chip is-${st}`} data-testid={`bf-bill-status-${row.no}`}>{BILLING_LABEL[st]} · {row.billing.firm_name}</span>;
  if (row.preview || !firms?.firms.length) return null;
  const ids = firms.firms.map((f) => f.id);
  const firm = ids.includes(pick) ? pick : ids.includes(firms.default_firm) ? firms.default_firm : ids[0];
  const go = () => {
    const name = firms.firms.find((f) => f.id === firm)?.name;
    if (!window.confirm(`Ai verificat comanda ${row.no}? O trimitem la facturare pe ${name}.`)) return;
    setBusy(true);
    sendToBilling(row.id, firm).then((r) => {
      if (r.status === "eroare") toast.error(`${row.no}: ${r.error}`);
      else toast.success(r.status === "trimis" ? `${row.no} a ajuns în NeoManager (${r.neo_no}) · ${r.firm_name}` : `${row.no} marcată „De trimis” · ${r.firm_name}`);
      onDone({ ...row, billing: { status: r.status, firm, firm_name: r.firm_name, error: r.error, neo_no: r.neo_no } });
    })
      .catch((e) => toast.error(typeof e?.response?.data?.detail === "string" ? e.response.data.detail : "Nu am putut trimite comanda")).finally(() => setBusy(false));
  };
  return (
    <span className="bf-bill-send">
      {firms.firms.length > 1 && (
        <select value={firm} onChange={(e) => setPick(e.target.value)} data-testid={`bf-bill-firm-${row.no}`}>
          {firms.firms.map((f) => <option key={f.id} value={f.id}>{f.name}</option>)}
        </select>
      )}
      <button type="button" className="st-btn st-btn--light" onClick={go} disabled={busy} data-testid={`bf-bill-send-${row.no}`}>
        {busy ? <Loader2 size={14} className="animate-spin" /> : <Send size={14} />} Trimite la facturare
      </button>
    </span>
  );
}
